<script>
import {computed, ref} from "vue";
import {useMutation} from "@vue/apollo-composable";
import {CREATE_CONTACT} from "@/graphql/operations/contact.ts";
import {message} from "ant-design-vue";
import useVuelidate from "@vuelidate/core";
import {required, email as emailValidate, minLength, maxLength, numeric} from "@vuelidate/validators";
import {useAuthStore} from "@/stores/auth";
import emailService from "@/stores/email";

export default {
  setup() {
    const {mutate: createContact, loading: updateLoading} = useMutation(CREATE_CONTACT);
    const authStore = useAuthStore();
    const first_name = ref("");
    const name = ref("");
    const email = ref("");
    const phone = ref("");
    const topic = ref("");
    const comment = ref("");
    const successMessage = ref("");
    const errorMessage = ref("");
    const loading = ref(false);

    const rules = computed(() => ({
      first_name: {required, minLength: minLength(1), maxLength: maxLength(50)},
      name: {required, minLength: minLength(1), maxLength: maxLength(50)},
      email: {required, emailValidate},
      phone: {required, numeric, minLength: minLength(10), maxLength: maxLength(20)},
      topic: {required, minLength: minLength(1), maxLength: maxLength(250)},
      comment: {required},
    }));

    const v$ = useVuelidate(rules, {first_name, name, email, phone, topic, comment});

    const onSubmit = async () => {
      loading.value = true;
      successMessage.value = "";
      errorMessage.value = "";

      try {
        const isValid = await v$.value.$validate();
        if (!isValid) {
          errorMessage.value = "Vui lòng kiểm tra lại thông tin!";
          message.error("Vui lòng kiểm tra lại thông tin!")
          return;
        }

        const response = await createContact({
          data: {
            first_name: first_name.value,
            name: name.value,
            phone: phone.value,
            email: email.value,
            topic: topic.value,
            comment: comment.value,
            contact_status: "pending",
          },
        });

        const now = new Date();
        const formatted = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ` +
            `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;

        if (response?.data?.createContact?.documentId) {
          const request = {
            email: email.value,
            admin_: 'dainq1002@gmail.com',
            contact_name: name.value,
            contact_email: email.value,
            contact_time: formatted,
            contact_content: topic.value,
          };
          await emailService.send(request);
          successMessage.value = "Gửi thành công! Chúng tôi sẽ liên hệ với bạn sớm.";
          message.success("Gửi thành công! Chúng tôi sẽ liên hệ với bạn sớm.")
          resetForm();
        } else {
          message.error("Gửi thất bại. Vui lòng thử lại.")
        }
      } catch (error) {
        message.error("Có lỗi xảy ra! Vui lòng thử lại.")
        errorMessage.value = "Có lỗi xảy ra! Vui lòng thử lại.";
        console.error(error);
      } finally {
        loading.value = false;
      }
    };

    const resetForm = () => {
      first_name.value = "";
      name.value = "";
      email.value = "";
      phone.value = "";
      topic.value = "";
      comment.value = "";

      successMessage.value = "";
      errorMessage.value = "";

      v$.value.$reset();
    };

    return {
      title: "Liên hệ",
      text: "Trang chủ",
      text1: "Liên hệ",
      v$,
      loading,
      authStore,
      first_name,
      name,
      email,
      phone,
      topic,
      comment,
      successMessage,
      errorMessage,
      onSubmit,
      updateLoading,
    };
  },
};
</script>

<template>
  <div v-if="loading" class="data_loading_">
    <div class="spinner-border text-danger" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div class="main-wrapper contact-us-page">
    <layouts-header v-if="!authStore.user"></layouts-header>
    <user-header v-if="authStore.user"></user-header>
    <breadcrumb :text="text" :text1="text1" :title="title"/>
    <div class="content blog-details contact-group">
      <div class="container">
        <h2 class="text-center mb-40">Thông tin liên hệ </h2>
        <div class="row mb-40">
          <div class="col-12 col-sm-12 col-md-6 col-lg-4">
            <div class="d-flex justify-content-start align-items-center details">
              <i
                  class="feather-mail d-flex justify-content-center align-items-center"
              ></i>
              <div class="info">
                <h4>Email </h4>
                <p><a href="mailto:info@example.com">ezcaulong@gmail.com</a></p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-4">
            <div class="d-flex justify-content-start align-items-center details">
              <i
                  class="feather-phone-call d-flex justify-content-center align-items-center"
              ></i>
              <div class="info">
                <h4>Số điện thoại </h4>
                <p>0914.616.818 </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-4">
            <div class="d-flex justify-content-start align-items-center details">
              <i
                  class="feather-map-pin d-flex justify-content-center align-items-center"
              ></i>
              <div class="info">
                <h4>Địa chỉ</h4>
                <p>14/333B Văn Cao, Đằng Lâm, Hải An, Hải Phòng</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="google-maps">
              <iframe
                  allowfullscreen=""
                  height="445"
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3728.959080191363!2d106.70334829999997!3d20.833358800000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x314a7aa0f323b65b%3A0x52251a205736d978!2zMzMzQiBQLiBWxINuIENhbywgxJDhurFuZyBMw6JtLCBI4bqjaSBBbiwgSOG6o2kgUGjDsm5nIDE4MDAwMCwgVmnhu4d0IE5hbQ!5e0!3m2!1svi!2s!4v1740726801186!5m2!1svi!2s"
                  style="border: 0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <section class="section dull-bg">
        <div class="container">
          <h2 class="text-center mb-40">
            Liên hệ với chúng tôi và cùng giải quyết mọi thắc mắc của bạn!
          </h2>
          <Form ref="formRef" v-model="formState" class="contact-us" @submit.prevent="onSubmit">
            <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>
            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <div class="row">
              <div class="col-12 col-sm-12 col-md-6 mb-3">
                <label class="form-label" for="first-name">Họ và tên đệm <span class="text-danger">*</span></label>
                <input id="first-name" v-model="first_name" class="form-control" maxlength="50"
                       placeholder="Họ và tên đệm"
                       type="text"/>
                <div v-if="v$.first_name.$error" class="text-danger">Vui lòng nhập họ và tên đệm của bạn</div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 mb-3">
                <label class="form-label" for="last-name">Tên <span class="text-danger">*</span></label>
                <input id="last-name" v-model="name" class="form-control" maxlength="50" placeholder="Tên" type="text"/>
                <div v-if="v$.name.$error" class="text-danger">Vui lòng nhập tên của bạn</div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 mb-3">
                <label class="form-label" for="e-mail">Email <span class="text-danger">*</span></label>
                <input id="e-mail" v-model="email" class="form-control" placeholder="Email" type="email"/>
                <div v-if="v$.email.$error" class="text-danger">
                  {{
                    v$.email.$errors[0].$message === "Value is not a valid email address" ? "Email không hợp lệ" : "Vui lòng nhập email"
                  }}
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 mb-3">
                <label class="form-label" for="phone">Số điện thoại <span class="text-danger">*</span></label>
                <input id="phone" v-model="phone" class="form-control" maxlength="50" placeholder="Số điện thoại"
                       type="text"/>
                <div v-if="v$.phone.$error" class="text-danger">Vui lòng nhập số điện thoại</div>
              </div>
            </div>
            <div class="row">
              <div class="col mb-3">
                <label class="form-label" for="subject">Chủ đề <span class="text-danger">*</span></label>
                <input id="subject" v-model="topic" class="form-control" maxlength="250" placeholder="Chủ đề"
                       type="text"/>
                <div v-if="v$.topic.$error" class="text-danger">Vui lòng nhập chủ đề</div>
              </div>
            </div>
            <div>
              <label class="form-label" for="comments">Bình luận <span class="text-danger">*</span></label>
              <textarea id="comments" v-model="comment" class="form-control" placeholder="Bình luận"
                        rows="3"></textarea>
              <div v-if="v$.comment.$error" class="text-danger">Vui lòng nhập bình luận của bạn</div>
            </div>
            <button class="btn btn-secondary d-flex align-items-center" type="submit">
              Gửi<i class="feather-arrow-right-circle ms-2"></i>
            </button>
          </form>
        </div>
      </section>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<style scoped>
.data_loading_ {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.15);
}
</style>
